import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ChildActivationEnd, NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { buffer, filter, map, takeUntil, tap } from "rxjs/operators";
import { Spinner } from "src/app/core/services/spinner.service";
import { CONTRACT_ROLES } from "src/app/shared/enums/admin-enum";
import { PATH_ROUTING } from "src/app/shared/enums/routing-enums";
import { Profile } from "src/app/shared/model/profile.model";
import { ProfileService } from "src/app/shared/service/profile.service";
import { ContractService } from "./services/contract.service";

@Component({
  selector: "app-contracts",
  templateUrl: "./contracts.component.html",
  styleUrls: ["./contracts.component.scss"]
})
export class ContractsComponent implements OnInit, OnDestroy {
  PATH_ROUTING = PATH_ROUTING;
  loginUser: Profile;
  isInCreateScreen: boolean;
  ngUnsubscribe$: Subject<any>;
  constructor(
    private spinner: Spinner,
    private contractService: ContractService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.isInCreateScreen = false;
  }

  ngOnInit() {
    this.ngUnsubscribe$ = new Subject();
    this.setUpForIsInCreateContractScreen();
    this.profileService.getUserProfile().subscribe(profile => {
      this.loginUser = new Profile(profile);
    });
  }

  setUpForIsInCreateContractScreen() {
    if (this.firstInitWithCreateContractPage()) {
      this.isInCreateScreen = true;
    }
    const routeEndEvent$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd));

    this.router.events
      .pipe(
        filter(
          e => e instanceof ChildActivationEnd && e.snapshot.component === this.route.component
        ),
        buffer(routeEndEvent$),
        map(([ev]) => (ev as ChildActivationEnd).snapshot.firstChild.data),
        tap(data => (this.isInCreateScreen = data.action && data.action === "create")),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe();
  }

  firstInitWithCreateContractPage() {
    return (
      this.router.url === "/" + PATH_ROUTING.PATH_CONTRACT + "/" + PATH_ROUTING.PATH_CREATE_CONTRACT
    );
  }

  isLoginUserViewer() {
    return this.loginUser.hasContractRole(CONTRACT_ROLES.CONTRACT_VIEWER);
  }

  migrateContracts(smartSheetFile: File) {
    if (!smartSheetFile) {
      return;
    }
    this.spinner.show();
    this.contractService.saveMass(smartSheetFile).subscribe(response => {
      console.log(response);
      this.spinner.hide();
    });
  }
  
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
